import {
	PRODUCT_TYPE_CONFIGURABLE,
	PRODUCT_TYPE_BUNDLE,
	PRODUCT_TYPE_GROUPED,
	PRODUCT_TYPE_GIFTCARD,
} from '@bluheadless/ui-logic/src/constants'
import { useProductContext } from '@bluheadless/ui-logic/src/providers/product'
import ConfigurableOptions from './configurable'
import BundleOptions from './bundle'
import GroupedOptions from './grouped'
import GiftcardOptions from './giftcard'
import SkeletonList from '../skeleton/list/skeleton-list'

const ProductOptionsSkeleton = () => <SkeletonList height={20} rows={2} />

const ProductOptions = ({ attributesProductImage, onClick, pageContext, pageId, widgetContext, isSticky }) => {
	const productContextValue = useProductContext()

	if (!productContextValue) {
		return null
	}

	const [
		{
			product: { type, configurableOptions, bundleOptions, giftcardOptions } = {},
			bundleProducts,
			childrenProductsLoading,
			bundleProductsLoading,
		} = {},
	] = productContextValue

	return (() => {
		switch (type) {
			case PRODUCT_TYPE_CONFIGURABLE:
				if (childrenProductsLoading) {
					return <ProductOptionsSkeleton />
				}
				return (
					<ConfigurableOptions
						configurableOptions={configurableOptions}
						attributesProductImage={attributesProductImage}
						onClick={onClick}
						isSticky={isSticky}
					/>
				)
			case PRODUCT_TYPE_BUNDLE:
				if (bundleProductsLoading) {
					return <ProductOptionsSkeleton />
				}
				return <BundleOptions options={bundleOptions} products={bundleProducts} />
			case PRODUCT_TYPE_GROUPED:
				if (childrenProductsLoading) {
					return <ProductOptionsSkeleton />
				}
				return <GroupedOptions pageContext={pageContext} pageId={pageId} widgetContext={widgetContext} />
			case PRODUCT_TYPE_GIFTCARD:
				return <GiftcardOptions options={giftcardOptions} />
			default:
				return null
		}
	})()
}

export default ProductOptions
